import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FONT_SANS } from '../constants';
import { colors } from '../theme/colors';
import { useLanguage } from '../context/LanguageContext';

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
`;

const Label = styled.p`
  font-family: ${FONT_SANS};
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  color: ${colors.inkMuted};
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const Track = styled.div`
  position: relative;
  height: 8px;
  background: rgba(44, 42, 41, 0.08);
  border-radius: 999px;
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  width: ${({ $pct }) => $pct}%;
  background: linear-gradient(
    90deg,
    ${colors.accent},
    ${colors.couponMedium},
    ${colors.couponEpic}
  );
  border-radius: 999px;
  transition: width 1s cubic-bezier(0.22, 1, 0.36, 1);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.35), transparent);
    background-size: 200% 100%;
    animation: ${shimmer} 2s linear infinite;
  }
`;

const Pct = styled.span`
  font-family: ${FONT_SANS};
  font-size: 12px;
  font-weight: 700;
  color: ${colors.inkSoft};
`;

function Progress({ target = 88, animate = true }) {
  const { t } = useLanguage();
  const [pct, setPct] = useState(animate ? 0 : target);

  useEffect(() => {
    if (!animate) return undefined;
    const timer = window.setTimeout(() => setPct(target), 120);
    return () => window.clearTimeout(timer);
  }, [animate, target]);

  return (
    <Wrapper>
      <Label>{t.progress.label}</Label>
      <Track role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
        <Fill $pct={pct} />
      </Track>
      <Pct>{t.progress.pct.replace('{pct}', String(pct))}</Pct>
    </Wrapper>
  );
}

export default Progress;
